import { parse } from 'node-html-parser';
import { asset, resolve } from '$app/paths';
import { browser } from '$app/environment';

export async function loadOldPage(url: string, origFetch = fetch) {
	try {
		const fetchUrl = browser // || true
			? asset(`/woer/${url.replace(/^\//, '')}`)
			: `http://woer-static/${url.replace(/^\//, '')}`;

		// console.log(
		// 	'loadOldPage',
		// 	url,
		// 	fetchUrl,
		// 	// import.meta.env.BASE_URL,
		// 	asset(`/woer/${url.replace(/^\//, '')}`)
		// );

		const data = await origFetch(fetchUrl, { mode: 'same-origin' });

		const doc = parse(new TextDecoder('windows-1251').decode(await data.arrayBuffer()));

		// console.log('doc length', doc.innerHTML.length);
		// console.log('html parse', doc.querySelector('main[role="main"]')?.innerHTML);

		doc.querySelectorAll('a').forEach((a) => {
			a.setAttribute(
				'href',
				resolve(
					`/${a
						.getAttribute('href')
						?.replace(/^https?\:\/\/w+?\.?woer\.ru/, '')
						.replace(/^\/+/, '')
						.replace(/index\.php\?option=com_content\&amp;task=view\&amp\;id=(\d+)/i, 'view/$1')
						.replace(/index\.php\?option=com_content\&task=view\&id=(\d+)/i, 'view/$1')
						.replace(/\?cat=(\d+)/i, 'cat/$1')
						.replace(/\?page=(\d+)/i, 'page/$1')}`
				)
			);

			if (/javascript:history\.go\(-1\)/i.test(a.getAttribute('href') ?? '')) {
				a.setAttribute('onclick', 'history.go(-1); return false;');
				a.setAttribute('href', '');
			}
		});

		// doc.querySelectorAll('img').forEach((img) => {
		// 	console.log('img', img.getAttribute('src'));
		// 	img.setAttribute('src', `${import.meta.env.BASE_URL}/www.ko-ki.ru/${img.getAttribute('src')}`);
		// });

		return doc.querySelector('.opisanie')?.innerHTML ?? '';
	} catch (e) {
		console.log('loadOldPage error', e);
		return '';
	}
}
